// Generated by Melange

import * as Stdlib__List from "melange/list.js";

function getCurrentJob(route, jobCategories) {
  let jobId;
  if (/* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Landing */ 0) {
    jobId = "";
  } else {
    const id = route._2;
    jobId = /* tag */ typeof id === "number" || typeof id === "string" || id.TAG !== /* Job */ 0 ? "" : id._0;
  }
  let jobCategory;
  try {
    jobCategory = Stdlib__List.find((function (jc) {
      try {
        return Stdlib__List.exists((function (j) {
          return j.slug === jobId;
        }), jc.jobs);
      }
      catch (exn){
        return false;
      }
    }), jobCategories);
  }
  catch (exn){
    jobCategory = {
      name: "",
      jobs: /* [] */ 0
    };
  }
  try {
    return Stdlib__List.find((function (j) {
      return j.slug === jobId;
    }), jobCategory.jobs);
  }
  catch (exn$1){
    return {
      name: "",
      id: 0,
      slug: "",
      city: "",
      experience: "",
      description: "",
      requirements: "",
      responsibilities: "",
      speciality: "",
      conditions: ""
    };
  }
}

export {
  getCurrentJob,
}
/* No side effect */
